import { EMPTY_STRING_VALUE } from "../membersportal/Consts";
import { IWorkflowSearchResult } from "../repertoire/types/IWorkflowSearchResult";

// TODO PRODUCT BACKLOG ITEM 47583
// this mapping should not be happening on frontend
export const parseWorkflowsToSearchResult = (workflowResults: any[]): IWorkflowSearchResult[] => {
        const workflowSearchResultItems: IWorkflowSearchResult[] = [];

        for (let x = 0; x < workflowResults.length; x++) {
            const workflowSearchResultItem = {
                assignedTo: !workflowResults[x].assignedTo ? EMPTY_STRING_VALUE : workflowResults[x].assignedTo.toLowerCase(),
                entityType: !workflowResults[x].entityType ? EMPTY_STRING_VALUE : workflowResults[x].entityType,
                entityName: !workflowResults[x].entityName ? EMPTY_STRING_VALUE : workflowResults[x].entityName,
                references: Object.keys(workflowResults[x]?.references ?? {}).length === 0 ? EMPTY_STRING_VALUE : JSON.stringify(workflowResults[x]?.references).replace(/"/g, ''),
                status: !workflowResults[x].status ? EMPTY_STRING_VALUE : workflowResults[x].status,
                workflowType: !workflowResults[x].workflowType ? EMPTY_STRING_VALUE : workflowResults[x].workflowType,
                values: Object.keys(workflowResults[x]?.values ?? {}).length === 0 ? EMPTY_STRING_VALUE : JSON.stringify(workflowResults[x]?.values).replace(/"/g, ''),
                setType: !workflowResults[x].setType ? EMPTY_STRING_VALUE : workflowResults[x].setType,
                entityID: !workflowResults[x].entityID ? EMPTY_STRING_VALUE : workflowResults[x].entityID,
                selected: false,
                dateCreated: new Date(workflowResults[x].dateCreated).toLocaleDateString('en-GB'),
                ID: !workflowResults[x].id ? EMPTY_STRING_VALUE : workflowResults[x].id.toString()
            };

            workflowSearchResultItems.push(workflowSearchResultItem);
        }

        return workflowSearchResultItems;
    }
